<template>
  <vx-card no-shadow>
    <vs-prompt
      title="Add new Question"
      @cancel="val = ''"
      @accept="acceptAddQuestionPrompt"
      @close="closeAddQuestionPrompt"
      :active.sync="addQuestionPrompt"
    >
      <div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Title</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <i8n-input
              label=""
              placeholder="Question..."
              :content.sync="title"
              class="w-full"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Help Text</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <i8n-textarea
              placeholder="Help Text..."
              :content.sync="helpText"
              class="w-full"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Points</span>
          </div>
          <div class="vx-col">
            <vs-input v-validate="'numeric'" name="points" v-model="points" />
            <div class="text-danger text-sm" v-show="errors.has('points')">
              {{ errors.first("points") }}
            </div>
          </div>
        </div>
      </div>
    </vs-prompt>

    <h2 class="mb-6">Questions</h2>

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="questions"
      @selected="onQuestionClicked(selected)"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <div
            @click="addQuestionPrompt = true"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add Question</span>
          </div>
          <!-- SAVE REORDER -->
          <div
            @click="saveReorder"
            v-if="orderChanged"
            class="
              vs-component vs-button
              p-3
              mb-4
              mr-4
              flex
              items-center
              justify-center
              text-lg
              font-medium
              vs-button-primary vs-button-filled
            "
          >
            <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-white">SAVE REORDER</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                questions.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : questions.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Question</vs-th>
        <vs-th sort-key="formattedQuestionType">Type</vs-th>
        <vs-th sort-key="points">Points</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <draggable
          :list="questions"
          tag="tbody"
          @start="drag = true"
          @end="
            drag = false;
            orderChanged = true;
          "
        >
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            v-bind:class="{ questionDisabled: !tr.active }"
          >
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ $translate(tr.title) }}
              </p>
            </vs-td>

            <vs-td>
              <p>{{ questionTypeMap[tr.questionType] }}</p>
            </vs-td>

            <vs-td>
              <p>{{ tr.points }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EyeOffIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="toggleDisabled(tr)"
              />
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="ml-2"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="confirmDelete(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </draggable>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  props: {
    surveyType: String,
  },
  data() {
    return {
      orderChanged: false,
      questionTypeMap: {
        1: "Multiple Choice",
        2: "Text Input",
        3: "Media Upload",
        0: "None",
      },
      surveyId: "",
      moduleId: "",
      lessonId: "",
      surveyLesson: null,
      drag: false,
      query: "*",

      addQuestionPrompt: false,
      title: "",
      helpText: "",
      points: 0,

      questions: [],

      selected: [],
      itemsPerPage: 100,
      isMounted: false,

      itemIdToDelete: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.questions.length;
    },
  },
  methods: {
    saveReorder: function () {
      this.$vs.loading();

      const url =
        process.env.VUE_APP_API +
        "/Surveys/" +
        this.surveyType +
        "/" +
        this.surveyId +
        "/modules/" +
        this.moduleId +
        "/lessons/" +
        this.lessonId;
      this.surveyLesson.questions = this.questions;
      this.$http
        .put(url, this.surveyLesson)
        .then((resp) => {
          console.log("Lesson updated: ", resp.data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
          this.orderChanged = false;
        });
    },
    getQuestions: function () {
      this.$vs.loading();

      const url =
        process.env.VUE_APP_API +
        "/Surveys/" +
        this.surveyType +
        "/" +
        this.surveyId +
        "/modules/" +
        this.moduleId +
        "/lessons/" +
        this.lessonId; /* +
        "/Questions?query=" +
        this.query;*/

      this.$http
        .get(url)
        .then((resp) => {
          console.log(resp.data);
          this.surveyLesson = resp.data.surveyLesson;
          this.questions = this.surveyLesson.questions;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onQuestionClicked(question) {
      this.$router
        .push({
          name: "admin-survey-question",
          params: {
            surveyType: this.surveyType,
            surveyId: this.surveyId,
            moduleId: this.moduleId,
            lessonId: this.lessonId,
            questionId: question.id,
          },
        })
        .catch(() => {});
    },

    acceptAddQuestionPrompt() {
      this.$vs.loading();

      const payload = {
        title: this.title,
        helpText: this.helpText,
        points: parseInt(this.points),
      };

      const url =
        process.env.VUE_APP_API +
        "/Surveys/" +
        this.surveyType +
        "/" +
        this.surveyId +
        "/modules/" +
        this.moduleId +
        "/lessons/" +
        this.lessonId +
        "/questions";

      this.$http
        .post(url, payload)
        .then((resp) => {
          console.log(resp.data);

          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Question added",
            });

            this.$router
              .push({
                name: "admin-survey-question",
                params: {
                  surveyType: this.surveyType,
                  surveyId: this.surveyId,
                  moduleId: this.moduleId,
                  lessonId: this.lessonId,
                  questionId: resp.data.questionId,
                },
              })
              .catch(() => {});

            //this.getQuestions();
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not add question: " + resp.data.error,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not add question: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    closeAddQuestionPrompt() {},

    confirmDelete(itemId) {
      this.itemIdToDelete = itemId;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete the Question?",
        accept: this.deleteItem,
      });
    },
    deleteItem() {
      const url =
        process.env.VUE_APP_API +
        "/Surveys/" +
        this.surveyType +
        "/" +
        this.surveyId +
        "/modules/" +
        this.moduleId +
        "/lessons/" +
        this.lessonId +
        "/questions/" +
        this.itemIdToDelete;

      this.$http
        .delete(url)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Question deleted",
          });

          this.getQuestions();
        })
        .catch((err) => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not delete Question: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    editData(data) {
      console.log("Edit:", data);
    },

    toggleDisabled(question) {
      this.$vs.loading();

      question.active = !question.active;
      const payload = {
        Active: question.active,
      };

      this.$http
        .put(
          process.env.VUE_APP_API +
            "/Surveys/" +
            this.surveyType +
            "/" +
            this.surveyId +
            "/modules/" +
            this.moduleId +
            "/lessons/" +
            this.lessonId +
            "/questions/" +
            question.id +
            "/info/active",
          payload
        )
        .then((resp) => {
          console.log("Toggle response", resp.data);
        })
        .catch((err) => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save question: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getStatusColor(status) {
      if (status === true) return "success";
      return "danger";
    },
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = "0";
    this.lessonId = "0";

    if (this.surveyType === "4") {
      this.moduleId = this.$route.params.moduleId;
      this.lessonId = this.$route.params.lessonId;
    }

    this.getQuestions();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.questionDisabled {
  opacity: 0.5;
}
</style>
